import { notification } from 'antd';
import {
    addStory,
    deleteStory,
    getStoriesForGuide as getStoriesForGuideFromDB,
    patchStory,
} from 'api/story-items.api';
import { parse } from 'utils/error-parser';
import {
    findOriginal,
    getChangesBetweenItemSets,
} from 'utils/sortable-item-utils';
import {
    FAILED_LOADING_STORY_ITEMS_FOR_GUIDE,
    FAILED_SAVING_STORY_ITEMS,
    STARTED_LOADING_STORY_ITEMS_FOR_GUIDE,
    STARTED_SAVING_STORY_ITEMS,
    SUCCESS_LOADING_STORY_ITEMS_FOR_GUIDE,
    SUCCESS_SAVING_STORY_ITEMS,
} from './action-types';
import { getStoriesForGuide } from './selectors';

/**
 * Loads the story items associated to a guide
 *
 * @param {Id} guideId
 */
export const loadStoriesForGuide = (guideId) => {
    return async (dispatch, getState) => {
        dispatch({ type: STARTED_LOADING_STORY_ITEMS_FOR_GUIDE, guideId });
        try {
            const payload = await getStoriesForGuideFromDB(guideId);
            dispatch({
                type: SUCCESS_LOADING_STORY_ITEMS_FOR_GUIDE,
                guideId,
                payload,
            });
            return getStoriesForGuide(getState(), guideId);
        } catch (error) {
            const errorText = parse(error);
            dispatch({
                type: FAILED_LOADING_STORY_ITEMS_FOR_GUIDE,
                guideId,
                error: errorText,
            });
        }
    };
};

/**
 * Saves the stories that have changed
 *
 * @param {Id} guideId
 * @param {StoryItem[]} current
 * @param {StoryItem[]} original
 */
export const saveChangedStories = (guideId, current, original) => {
    return async (dispatch) => {
        const {
            newItems,
            deletedItems,
            editedItems,
        } = getChangesBetweenItemSets(current, original);

        dispatch({ type: STARTED_SAVING_STORY_ITEMS });
        const willAddStories = newItems.map((newStory) => addStory(newStory));
        const willDeleteStories = deletedItems.map((deletedStory) =>
            deleteStory(deletedStory),
        );
        const willPatchStories = editedItems.map((editedStory) =>
            patchStory(editedStory, findOriginal(editedStory, original)),
        );

        try {
            await Promise.all([
                ...willAddStories,
                ...willDeleteStories,
                ...willPatchStories,
            ]);
            await dispatch(loadStoriesForGuide(guideId));
            dispatch({ type: SUCCESS_SAVING_STORY_ITEMS });
        } catch (error) {
            const errorText = parse(error);
            dispatch({
                type: FAILED_SAVING_STORY_ITEMS,
                error: errorText,
            });
            notification.error({
                message: 'Error saving story items',
                description: errorText,
            });
            throw error;
        }
    };
};
